export const verificationTranslations = {
  VERIFICATION_SUCCESS_TITLE: 'Yes, your account has been verified!',
  VERIFICATION_SUCCESS_SUBTITLE: 'You\'re now a real someone in Tranzer. You can plan, buy and take the ride.',

  VERIFICATION_ERROR_TITLE: 'Account confirmation failed.',
  VERIFICATION_ERROR_SUBTITLE: 'We\'ve dropped a new link in your inbox. Please try again.',
};
